import classNames from 'classnames';
import { BackgroundThemeRevision, ColorId } from 'referral-types';
import { useColorStyles } from '../../../hooks/useColorStyles';

export const SolidBackground = (props: { themeRevision?: Partial<BackgroundThemeRevision> }) => {
  const { themeRevision } = props;
  const colorStyles = useColorStyles(themeRevision?.colorId1 || ColorId.Gray4);
  const backgroundClass = colorStyles.background;

  return <div className={classNames(backgroundClass, 'relative -z-10 h-full w-full')} />;
};
